<template>
  <!-- Mahmoud El farargy, AUG 6th, 2023 -->
  <NuxtLink 
    :to="productLink" 
    class="" 
    :onclick="item.ad == 0 ? null : onClickProduct" 
    :data-portal-page="portalPage"
    @click.prevent="handleProductClick"
  >
    <div v-if="item"
      :class="[
        `${!disableHoverEffect ? 'product__card__hover ' : ''} ${cardBorders} product_item relative h-full min-w-[100px] pb-0 w-full border ${isAd ? 'bg-[rgba(248,184,78,0.18)]' : 'bg-white opacity-100'} rounded-[0.438rem] xl:rounded-[0.46rem]`.trim(),
        { 'color-extracted': enableColorExtraction && extractedColor && !isAd }
      ]"
      :style="dynamicShadowStyle"
      @mouseenter="handleImageHover"
      @mouseleave="handleImageLeave">
      <!-- flags -->
      <span v-if="isPinned"
        class="absolute top-2.5 bg-white shadow-[0px_3px_6px_#00000029] md:top-3 rtl:left-2.5 rtl:right-auto left-auto right-2.5 grid place-content-center z-[3] text-[0.813rem] font-bold  w-[2.20rem] h-[2.20rem] 3xl:w-[2.25rem] 3xl:h-[2.25rem] rounded-full">
        <span class="py-0.5 rounded-full">
          <img :src="pinnedIcon" class="w-[25px] h-[25px] object-contain" alt :width="25" :height="25" />
        </span>
      </span>
      <!--Product type - top -->
      <span v-else-if="productType && productTypeId !== 'retail'"
        class="gap-1 w-max min-w-[3.688rem] z-[1] text-center px-1.5 py-1.5 3xl:py-2 absolute top-2 rtl:left-3 bg-primary text-white rtl:right-auto right-3 left-auto font-normal text-[0.72rem] flex items-center rounded-[0.563rem]">
        <span class="mx-auto">{{ productType }}</span>
      </span>
      <!-- ad flag -->
      <span v-if="isAd"
        class="absolute rtl:left-0 rtl:right-auto z-[1] py-1 px-2 left-auto right-0 bg-[#00000066] text-white text-[0.813rem] font-bold rtl:rounded-[5px_0px] rounded-[0px_5px]">
        {{ $t('general.ad') }}
      </span>
      <!-- veritifed flag -->
      <span v-else-if="isVerified"
        class="absolute z-[1] top-[-14px] rtl:left-[-10px] rtl:right-auto left-auto right-[-10px] text-[0.813rem] font-bold rtl:rounded-[5px_0px] rounded-[0px_5px]">
        <img src="@/assets/icons/verify_white.svg" class="w-[25px] h-[25px]" alt :width="26" :height="26" />
      </span>
      <!-- visual info -->
      <div class="relative cursor-pointer">
        <!-- product image -->
        <div class="z-0 product__image__container w-full "
          :title="item && item[finalizedNameKey] ? trimText(item[finalizedNameKey], 100) : ''">
          <div class="product__thumbnail p-[0.3rem] md:p-[0.4rem] lg:p-[0.4.2rem] xl:p-[0.4.4rem]">
            <img @error="onImageError"
              class="w-full max-h-[13.375rem] min-h-[12.9rem] h-full block object-contain object-center rounded-[0.438rem] xl:rounded-[0.46rem]"
              :src="item.image || placeholderImg" alt="" loading="lazy" width="148px" height="155px"
              draggable="false" />
            <!-- <NuxtImg
              @error="onImageError"
              class="w-full h-full block object-contain object-center"
              :src="item.image || placeholderImg"
              :alt="item[finalizedNameKey]"
              loading="lazy"
              width="260"
              height="169"
              draggable="false"
              sizes='xs:240px sm:260px'
              quality='60'
              format='webp'
              densities="x1 x2"
            /> -->
          </div>
        </div>
        <!-- favorite/unfavorite product -->
        <div class="absolute top-2.5 md:top-3 rtl:right-2.5 rtl:left-auto right-auto left-2.5">
          <client-only>
            <!-- favorite button -->
            <FavoriteBtn :favoriteProductsIDs="favoriteProductsIDs" :isProductDesign="true" :id="item && item.id" />
          </client-only>
        </div>
        <!-- delete product from hestory -->
        <div v-if="hasDeleteItem" class="absolute top-2.5 md:top-3 rtl:right-14 rtl:left-auto right-auto left-14">
          <client-only>
            <button type="button" @click="allowToRemoveItem"
              :class="` z-10 bg-white hover:brightness-90 transition-[filter,transform] duration-150 shadow-[0px_3px_6px_#00000029] w-[2.20rem] h-[2.20rem] 3xl:w-[2.25rem] 3xl:h-[2.25rem] rounded-full`.trim()">

              <span
                class=" flex justify-center items-center favorite__btn select-none w-full h-full bg-transparent border-0 cursor-pointer rounded-[6px] md:rounded-[7px]mx-auto mb-[-0.25rem]"
                title="delete">
                <img class="object-contain heart heart-icon mx-auto mb-0.5 w-[15px]" :draggable="false"
                  src="../../../assets/icons/Delete.svg" alt="delete" />
                <!-- <span class="sr-only">{{ liked ? 'Unfavorite' : 'Favorite' }}</span> -->
              </span>
            </button>
          </client-only>
        </div>
        <!-- product rating -->
        <span
          v-if="(typeof item.ratings_avg === 'string' || typeof item.ratings_avg === 'number') && parseInt(item.ratings_avg) > 0"
          class="gap-1.5 w-max px-2 md:px-2.5 py-0.5 absolute bottom-3 rtl:right-2.5 rtl:left-auto right-auto left-2.5 bg-white text-black font-bold text-[0.72rem] 3xl:text-[0.75rem] flex items-center rounded-[1.563rem]">
          <span>{{ arabizeNumbers(Number(item.ratings_avg).toLocaleString()) }}</span>
          <img :src="starIcon" alt="" width="20" height="20" class="w-[1.25rem] h-[1.25rem] object-contain" />
        </span>
        <div class="absolute z-[1] bottom-3 rtl:left-2.5 rtl:right-auto left-auto right-2.5">
          <!-- productType -->
          <span v-if="productTypeId !== 'retail' && isPinned"
            class="gap-1 w-max min-w-[3.688rem] z-[1] text-center px-1.5 py-1.5 3xl:py-2 bg-primary text-white rtl:right-auto right-3 font-normal text-[0.72rem] flex items-center rounded-[0.563rem]">
            <span class="mx-auto">{{ productType }}</span>
          </span>
          <!-- product views -->
          <span v-if="item.views && Number(item.views) > 0"
            class="gap-1 w-max px-2 md:px-2.5 py-0.5 bg-white  text-black font-bold text-[0.72rem] 3xl:text-[0.75rem] flex items-center rounded-[1.563rem]">
            <img :src="viewsIcon" alt="" height="20" width="20" class="w-[1.25rem] h-[1.25rem] object-contain" />
            <span>{{ arabizeNumbers(Math.abs(Number(item.views))) }}</span>
          </span>
        </div>

      </div>

      <!-- title & price -->
      <div class="min-h-[3.70rem] px-2">
        <div class="mb-0 text-black">
          <!-- title -->
          <strong v-if="item[finalizedNameKey]" :title="item[finalizedNameKey]"
            class="product-title font-[600] text-[#515151] text-[0.8rem] md:text-[0.9rem] lg:text-[0.94rem] 3xl:text-[1.1rem] ellipsis-x1">{{
              item[finalizedNameKey] }}</strong>
        </div>
        <!-- Description according to the product type -->
        <DescriptionPart :item="item" />
      </div>
    </div>
  </NuxtLink>
</template>

<script>
import crownIcon from "@/assets/images/crown.svg";
import starIcon from "@/assets/icons/star.svg";
import favedIcon from "@/assets/images/heart-faved.svg";
import unfavedIcon from "@/assets/images/heart-unfaved.svg";
import placeholderImg from "@/assets/images/placeholder(doNotRemove).jpg";
import { FavoriteBtn } from "@/components";
import VerifiedIcon from "@/assets/shared/icons/verified.vue";
import DescriptionPart from "./DescriptionPart.vue";
import viewsIcon from "@/assets/icons/views.svg";
import pinnedIcon from "@/assets/icons/pin.svg";
import { trimText, buildProductLink, buildStoreLink, arabizeNumbers, roundWithHalf, onImageError } from "@/helpers";
import { useImageColorExtraction } from "@/composables/useImageColorExtraction";

export default {
  setup() {
    const usedCookieLanguage = useCookie('localStorageCopy')?.value?.language || 'ar';
    const { extractDominantColor } = useImageColorExtraction();

    return {
      usedCookieLanguage,
      extractDominantColor
    }
  },
  data() {
    return {
      placeholderImg,
      viewsIcon,
      crownIcon,
      starIcon,
      pinnedIcon,
      favedIcon,
      unfavedIcon,
      isFavoriting: false,
      extractedColor: null,
      isExtractingColor: false
    };
  },
  emits:["prepareItemToDelete"],

  props: {
    favoriteProductsIDs: {
      type: Array,
      default: () => [],
      required: true
    },
    hasDeleteItem:{
          type: Boolean,
          default: false,
        },
    item: {
      type: Object,
      default: () => ({}),
      required: true
    },
    disableHoverEffect: {
      type: Boolean,
      default: false,
      required: false
    },
    disableVisitingStore: {
      type: Boolean,
      default: false,
      required: false
    },
    withAds: {
      type: Boolean,
      default: false,
      required: false
    },
    withPin: {
      type: Boolean,
      default: false,
      required: false
    },
    cardDesignId: {
      type: [Boolean, Number],
      default: false,
      required: false
    },
    portalPage: {
      type: String,
      required: false,
      default: null,
    },
    encodedFilterQuery: {
      type: String,
      required: false,
      default: "",
    },
    searchTerm: {
      type: String,
      required: false,
      default: "",
    },
    saveProductCardPosition: {
      type: Function,
      required: false,
      default: null,
    },
    shouldSavePosition: {
      type: Boolean,
      required: false,
      default: false,
    },
    enableColorExtraction: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    FavoriteBtn,
    VerifiedIcon,
    DescriptionPart
  },
  computed: {
    finalizedNameKey() {
      return this.nameKey || `name_${this.usedCookieLanguage}`;
    },
    finalizedDescriptionKey() {
      return this.descriptionKey || `description_${this.usedCookieLanguage}`;
    },
    productLink() {
      if(this.$props.encodedFilterQuery && this.$props.searchTerm){
        localStorage.setItem('encodedFilterQuery', this.$props.encodedFilterQuery);
        localStorage.setItem('searchTerm', this.$props.searchTerm);
      }
      
      const baseLink = buildProductLink(this.item, this.portalPage);
      
      // If portalPage is 'search', include query parameters from current route
      if (this.portalPage === 'search' && process.client) {
        const route = useRoute();
        const queryString = route.fullPath.split("?")[1];
        
        if (queryString) {
          // Include the encoded query string in the product link
          return `${baseLink}?${queryString}`;
        }
      }
      
      return baseLink;
    },
    storeLink() {
      const storeInfo = this.item?.store;
      return buildStoreLink(storeInfo?.username);
    },
    isAd() {
      return this.withAds && !!this.item?.ad;
    },
    isPinned() {
      return this.withPin && !!this.item?.pinned;
    },
    isVerified() {
      return !!this.item?.store_verified;
    },
    productTypeId() {
      return this.item?.product_type;
    },
    cardBorders() {
      return this.isAd ? 'border-[#F8B84E] border-[2px] overflow-hidden' : this.isVerified ? 'border-primary border-[2px]' : 'overflow-hidden hover:border-secondary/25 active:border-secondary/30 border-[#E9E9E9]';
    },
    productType() {
      switch (this.productTypeId) {
        case "wholesale":
          return this.$t('general.wholesale');
        case "retail":
          return this.$t('general.retail');
        case "offer":
          return this.$t('general.offer_noun');
        default:
          return "";
      }
    },
    dynamicShadowStyle() {
      // Don't apply color effects to ads
      if (!this.enableColorExtraction || this.isAd) {
        return {};
      }
      
      if (!this.extractedColor) {
        // Return default values when color not yet extracted
        return {
          '--shadow-r': '0',
          '--shadow-g': '0',
          '--shadow-b': '0',
          '--shadow-opacity': '0.1',
          '--bg-opacity': '0',
        };
      }
      
      // Extract RGB values from "r, g, b" format
      const [r, g, b] = this.extractedColor.split(',').map(val => val.trim());
      
      return {
        '--shadow-r': r || '128',
        '--shadow-g': g || '128',
        '--shadow-b': b || '128',
        '--shadow-opacity': '0.5', // Increased shadow opacity for more visibility
        '--bg-r': r || '128',
        '--bg-g': g || '128',
        '--bg-b': b || '128',
        '--bg-opacity': '0.08', // Subtle background color tint
      };
    },
  },
  methods: {
    arabizeNumbers,
    trimText,
    roundWithHalf,
    onImageError,
    async onClickProduct(){
        const model = 'product';
        const id = this.item.id;

        await this.makeRequest({
          url: `${this.APIREQUESTS.user.recordClick.url}/${model}/${id}`,
          method: this.APIREQUESTS.user.recordClick.method,
          includeUID: true
        }).then((res) => {
          if (!res?.status) {
          } else {
            // success
          }
        })
        .catch((err) => {
          //rejected
        });
      },
    visitStore(event) {
      if (this.disableVisitingStore) {
        return;
      }
      event?.preventDefault();
      const router = useRouter();
      router.push(this.storeLink);
    },
    allowToRemoveItem(event) {
      event.stopPropagation();
      event.preventDefault();
      // prepareItemToDelete(item){
        this.$emit('prepareItemToDelete' , this.item)
      // } 
    },
    async handleProductClick(event) {
      // Call onClickProduct for ad tracking if needed (don't await, fire and forget)
      if (this.item.ad != 0 && this.onClickProduct) {
        this.onClickProduct();
      }
      
      // If should save position and handler provided
      if (this.shouldSavePosition && this.saveProductCardPosition) {
        try {
          // Call save handler (this should return a Promise)
          const saveResult = this.saveProductCardPosition(this.item.id);
          
          // Navigate after save completes
          if (saveResult instanceof Promise) {
            await saveResult;
            this.$router.push(this.productLink);
          } else {
            // Small delay to ensure save completes if not a Promise
            setTimeout(() => {
              this.$router.push(this.productLink);
            }, 50);
          }
        } catch (error) {
          // Navigate even if save fails
          this.$router.push(this.productLink);
        }
      } else {
        // Normal navigation if no save handler
        this.$router.push(this.productLink);
      }
    },
    async handleImageHover() {
      // Only extract color if enabled and not already extracting
      if (!this.enableColorExtraction || this.isExtractingColor) {
        return;
      }

      // Get image URL
      const imageUrl = this.item?.image || this.placeholderImg;
      if (!imageUrl) {
        return;
      }

      // If color already extracted, no need to extract again
      if (this.extractedColor) {
        return;
      }

      // Extract color asynchronously
      this.isExtractingColor = true;
      try {
        const color = await this.extractDominantColor(imageUrl);
        this.extractedColor = color;
      } catch (error) {
        console.warn('Failed to extract color:', error);
        // Set default gray color on error
        this.extractedColor = '128, 128, 128';
      } finally {
        this.isExtractingColor = false;
      }
    },
    handleImageLeave() {
      // Reset extracted color when leaving (optional - you might want to keep it)
      // For now, we'll keep it cached for better performance
      // this.extractedColor = null;
    }
  }
};
</script>

<style lang="scss" scoped>
// Todo: remove the css code and only depend on Tailwind classes
.product__image__container {
  display: inline-block;

  .product__thumbnail {
    margin-left: auto;
    margin-right: auto;
    display: block;
    overflow: hidden;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    img {
      background: var(--light-gray);
    }
  }

  position: relative;

  &::before {
    display: block;
    content: "";
    width: 100%;

    min-height: 13.375rem;
    padding: 41%;

    @media (min-width: 1318px) {
      max-width: 16.313rem;
    }

    @media (max-width: 581px) {
      min-height: 12.688rem;
    }

    @media (max-width: 418px) {
      min-height: 11.779rem;
    }
  }
}

// Dynamic shadow and background styles for color extraction
.product__card__hover {
  transition: box-shadow 0.3s ease, background-color 0.3s ease;
  
  // Default shadow (when no color extracted or color extraction disabled)
  &:hover:not(.color-extracted) {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }
  
  // Dynamic shadow when color is extracted (increased size and opacity for more visibility)
  &.color-extracted:hover {
    box-shadow: 0 12px 32px rgba(
      var(--shadow-r, 0),
      var(--shadow-g, 0),
      var(--shadow-b, 0),
      var(--shadow-opacity, 0.5)
    );
  }
}

// Background color effect for non-ad items with extracted color
.product_item.color-extracted {
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: rgba(
      var(--bg-r, 255),
      var(--bg-g, 255),
      var(--bg-b, 255),
      var(--bg-opacity, 0.08)
    ) !important;
  }
}
</style>